import Cross from '@/assets/icons/Cross.svg';
import { HStack } from '@/elements/layout';

export const CloseIconAndText = () => (
  <HStack alignItems='center' justifyContent='center'>
    <Cross width='14px' height='14px' style={{ marginBottom: '2px' }} />
    <span>Close</span>
  </HStack>
);
